import api from './api';

export const ownerCommissionService = {
  /**
   * Récupérer les détails d'une facture de commission
   * @param {string} invoiceId - ID de la facture
   * @returns {Promise<Object>} Détails de la facture
   */
  async getInvoiceDetails(invoiceId) {
    try {
      const response = await api.get(`/owner/commissions/invoice/${invoiceId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de la facture:', error);
      throw error;
    }
  },

  /**
   * Récupérer toutes les factures de commission du propriétaire
   * @param {Object} params - Paramètres de pagination et filtres
   * @returns {Promise<Object>} Liste des factures avec pagination
   */
  async getOwnerInvoices(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.currency) queryParams.append('currency', params.currency);
      if (params.date_from) queryParams.append('date_from', params.date_from);
      if (params.date_to) queryParams.append('date_to', params.date_to);
      if (params.sort_by) queryParams.append('sort_by', params.sort_by);
      if (params.sort_order) queryParams.append('sort_order', params.sort_order);

      const response = await api.get(`/owner/commissions/invoices?${queryParams}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des factures:', error);
      throw error;
    }
  },

  /**
   * Récupérer les détails des payins d'une facture avec pagination
   * @param {string} invoiceId - ID de la facture
   * @param {Object} params - Paramètres de pagination
   * @returns {Promise<Object>} Détails des payins avec pagination
   */
  async getInvoicePayinsDetails(invoiceId, params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);

      const response = await api.get(`/owner/commissions/invoice/${invoiceId}/details?${queryParams}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des détails des payins:', error);
      throw error;
    }
  },

  /**
   * Télécharger le PDF d'une facture de commission
   * @param {string} invoiceId - ID de la facture
   * @returns {Promise<Blob>} Blob du PDF
   */
  async downloadInvoicePdf(invoiceId) {
    try {
      console.log('Appel API pour télécharger le PDF de la facture:', invoiceId);
      
      const response = await api.get(`/owner/commissions/invoice/${invoiceId}/pdf`, {
        responseType: 'blob',
        timeout: 60000 // 60 secondes de timeout pour la génération PDF
      });

      console.log('Réponse API reçue:', {
        status: response.status,
        size: response.data.size,
        type: response.data.type,
        headers: response.headers
      });

      // Vérifier la réponse
      if (response.status !== 200) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      if (!response.data || response.data.size === 0) {
        throw new Error('Aucune donnée PDF reçue du serveur');
      }

      return response.data;
    } catch (error) {
      console.error('Erreur détaillée lors du téléchargement du PDF:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: error.config
      });
      
      if (error.response?.status === 404) {
        throw new Error('Facture non trouvée');
      } else if (error.response?.status === 500) {
        throw new Error('Erreur du serveur lors de la génération du PDF');
      } else if (error.code === 'ECONNABORTED') {
        throw new Error('Timeout: La génération du PDF prend trop de temps');
      }
      
      throw error;
    }
  }
};

export default ownerCommissionService;